import { Location } from '../../../types/models/Location.model'

interface GetLocationCoordinates {
  (location: Location): { lat: number | undefined; lng: number | undefined }
}

const getLocationCoordinates: GetLocationCoordinates = (location) => {
  const { lat, lng, _geoloc, geoloc } = location || {}

  if (geoloc) {
    return {
      lat: parseFloat(geoloc.lat),
      lng: parseFloat(geoloc.lng)
    }
  }

  if (_geoloc) {
    return {
      lat: parseFloat(_geoloc.lat),
      lng: parseFloat(_geoloc.lng)
    }
  }

  return { lat, lng }
}

export default getLocationCoordinates
